import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { formatFieldValue } from 'helpers/Field';
import { QuoteMedia } from './components/QuoteMedia';
import { QuoteLink } from './components/QuoteLink';
import { useDomain } from 'components/domain/DomainProvider';
import { formatPlannedDateLabel } from 'helpers/formatPlannedDateLabel';
import i18n from 'components/translation/i18n';
import './QuoteField.scss';
/**
 * @component QuoteField
 * @since 1.0.0
 */
export function QuoteField(props) {
    var _a;
    const { data } = props;
    const domain = useDomain();
    const fieldValues = (data === null || data === void 0 ? void 0 : data.fieldValues) || [];
    // get public field values and not empty
    const filteredFieldValues = fieldValues.filter((fieldValue) => {
        var _a;
        return (fieldValue.field.visibility === 'PUBLIC' ||
            fieldValue.field.visibility === 'DYNAMIC_SALES_FORM') &&
            fieldValue.field.type !== 'HIDDEN' &&
            (typeof fieldValue.value === 'string'
                ? JSON.parse(fieldValue.value).value !== ''
                : typeof fieldValue.value === 'object'
                    ? ((_a = fieldValue.value) === null || _a === void 0 ? void 0 : _a.value) !== ''
                    : fieldValue.value !== '');
    });
    const sortedFieldValues = [...filteredFieldValues].sort((a, b) => a.field.order - b.field.order) ||
        [];
    const hasPlannedDate = Boolean((_a = domain.plannedDateInfo) === null || _a === void 0 ? void 0 : _a.hasPlannedDate);
    const hasFieldValues = sortedFieldValues.length > 0;
    if (!hasPlannedDate && !hasFieldValues) {
        return null;
    }
    return (React.createElement("div", { className: "quote-field-container" },
        hasPlannedDate && !(data === null || data === void 0 ? void 0 : data.directSale) && (data === null || data === void 0 ? void 0 : data.type) !== 'AGREEMENT' && (React.createElement("div", { className: "quote-field" },
            React.createElement("div", { className: "quote-field-title" }, i18n.t('Planned Date')),
            React.createElement("div", { className: "quote-field-value" }, formatPlannedDateLabel(data === null || data === void 0 ? void 0 : data.plannedDateStart, data === null || data === void 0 ? void 0 : data.plannedDateEnd, i18n.t('To be confirmed'))))),
        sortedFieldValues.map((fieldValue, index) => {
            var _a, _b;
            return (React.createElement("div", { key: index, className: classNames('quote-field', {
                    'quote-field--full-width': fieldValue.field.type === 'TEXTAREA'
                }) },
                React.createElement("div", { className: "quote-field-title" }, (_a = fieldValue.field.translations.find((t) => t.language.code === (data === null || data === void 0 ? void 0 : data.language))) === null || _a === void 0 ? void 0 : _a.title),
                fieldValue.field.type === 'URL' ? (React.createElement("div", { className: "quote-field-value" },
                    React.createElement(QuoteLink, { value: formatFieldValue(fieldValue.value, fieldValue.field.type, fieldValue.field) }))) : fieldValue.field.type === 'FILE' ? (React.createElement("div", { className: "quote-field-value" },
                    React.createElement(QuoteMedia, { style: "normal", value: formatFieldValue(fieldValue.value, fieldValue.field.type, fieldValue.field) }))) : (React.createElement("div", { className: "quote-field-value", dangerouslySetInnerHTML: {
                        __html: formatFieldValue(fieldValue.value, fieldValue.field.type, fieldValue.field, (_b = data === null || data === void 0 ? void 0 : data.language) !== null && _b !== void 0 ? _b : '', false, data === null || data === void 0 ? void 0 : data.subtotal.toString())
                    } }))));
        })));
}
